import { useSelector } from "store/useSelector";
import type { ExpandedTilesDataType } from "types/types";
import { useSegmentsForProcess } from "utils/customHooks/genericHooks";

export function useLatestSegmentForProcess(processId: string) {
  const segments = useSegmentsForProcess(processId);
  return segments?.[segments.length - 1] || null;
}

export function useExpandedTilesDataForProcess(
  processId: string
): ExpandedTilesDataType | undefined {
  return useSelector(state => state.legacy.expandedTilesData?.[processId]);
}
